/**
 * Routage des classes CSS custom d'un bloc (champ `css_classes` défini dans le back).
 *
 * Convention :
 *  - token préfixé `pv:` -> appliqué uniquement à la card de preview (préfixe retiré)
 *  - tout autre token    -> appliqué uniquement au conteneur de formulaire (comportement historique)
 *
 * Le fallback "formulaire" garantit la rétrocompatibilité : les valeurs déjà
 * stockées en base (ex. `block-usu`) gardent exactement leur comportement actuel.
 */
export const PREVIEW_PREFIX = 'pv:'

export type BlockCssClasses = {
  form: string
  preview: string
}

export function splitBlockCss(cssClasses: string | null | undefined): BlockCssClasses {
  const form: string[] = []
  const preview: string[] = []

  for (const token of (cssClasses ?? '').split(/\s+/)) {
    if (!token) continue

    if (token.startsWith(PREVIEW_PREFIX)) {
      const className = token.slice(PREVIEW_PREFIX.length)
      if (className) preview.push(className)
    } else {
      form.push(token)
    }
  }

  return { form: form.join(' '), preview: preview.join(' ') }
}

export default splitBlockCss
